import styled from 'styled-components';
import { Icon, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ListLink } from '@components/list.link';

export const HomeList = styled(List)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
  column-gap: 20px;
  row-gap: 20px;

  @media (max-width: 420px) {
    padding: 0;
    column-gap: 6px;
    row-gap: 6px;
  }
`;

export const HomeListItem = styled(ListItem)`
  max-width: max-content;

  @media (max-width: 420px) {
    padding: 0;
  }
`;

export const HomeListLink = styled(ListLink)`
  min-height: 56px;

  @media (max-width: 420px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const HomeIcon = styled(Icon)`
  font-size: 3rem;
`;

export const HomeListItemIcon = styled(ListItemIcon)`
  min-width: 68px;

  @media (max-width: 420px) {
    min-width: 56px;
  }
`;

export const HomeListItemText = styled(ListItemText)`
  & .MuiListItemText-primary {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.775);
  }
`;
